import { ENQUIRY_ENQUIRYSEARCH_ERR, ENQUIRY_ENQUIRYSEARCH_REQUEST, ENQUIRY_ENQUIRYSEARCH_SUCCESS, ENQUIRY_STUDENT_APPLICATION_FIND_ERR, ENQUIRY_STUDENT_APPLICATION_FIND_REQUEST, ENQUIRY_STUDENT_APPLICATION_FIND_SUCCESS, ENQUIRY_STUDENT_DETAILS_ERR, ENQUIRY_STUDENT_DETAILS_FILTER_REQUEST, ENQUIRY_STUDENT_DETAILS_FILTER_SUCCESS, ENQUIRY_STUDENT_DETAILS_REQUEST, ENQUIRY_STUDENT_DETAILS_SUCCESS, ENQUIRY_STUDENT_DETAILS_WITHOUT_PAGINATION_REQUEST, ENQUIRY_STUDENT_DETAILS_WITHOUT_PAGINATION_SUCCESS } from "../constants/enquiryConstant";

 export const enquiryStudentDetailsReducer = (state = {}, action) => {
   switch (action.type) {
     case ENQUIRY_STUDENT_DETAILS_REQUEST:
       return {
         ...state,
         enquiryStudentDetailsLoading: true,
       };
     case ENQUIRY_STUDENT_DETAILS_SUCCESS:
       return {
         ...state,
         enquiryStudentDetailsLoading: false,
         enquiryStudentDetailsSuccess: action.payload,
       };
     case ENQUIRY_STUDENT_DETAILS_ERR:
       return {
         ...state,
         enquiryStudentDetailsLoading: false,
         enquiryStudentDetailsErr: action.payload,
       };
     default:
       return state;
   }
 };

 export const enquiryStudentDetailsFilterReducer = (state = {}, action) => {
  switch(action.type) {
    case ENQUIRY_STUDENT_DETAILS_FILTER_REQUEST:
      return {
        ...state,
        enquiryStudentDetailsFilterLoading: true
      }
    case ENQUIRY_STUDENT_DETAILS_FILTER_SUCCESS:
      return {
        ...state,
        enquiryStudentDetailsFilterLoading: false,
        enquiryStudentDetailsFilterSuccess: action.payload
      }
    default:
      return state;
  }
 }

 export const enquiryStudentDetailsWithoutPaginationFindReducer = (state = {}, action) => {
  switch(action.type) {
    case ENQUIRY_STUDENT_DETAILS_WITHOUT_PAGINATION_REQUEST:
      return {
        ...state,
        enquiryStudentDetailsWithoutPaginationLoading: true
      }
    case ENQUIRY_STUDENT_DETAILS_WITHOUT_PAGINATION_SUCCESS:
      return {
        ...state,
        enquiryStudentDetailsWithoutPaginationLoading: false,
        enquiryStudentDetailsWithoutPaginationSuccess: action.payload
      }
    default:
      return state;
  }
 }

export const enquiryStudentApplicationFindReducer = (state = {}, action) => {
  switch (action.type) {
    case ENQUIRY_STUDENT_APPLICATION_FIND_REQUEST:
      return {
        ...state,
        enquiryStudentApplicationFindLoading: true,
      };
    case ENQUIRY_STUDENT_APPLICATION_FIND_SUCCESS:
      return {
        ...state,
        enquiryStudentApplicationFindLoading: false,
        enquiryStudentApplicationFindSuccess: action.payload,
      };
    case ENQUIRY_STUDENT_APPLICATION_FIND_ERR:
      return {
        ...state,
        enquiryStudentApplicationFindLoading: false,
        enquiryStudentApplicationFindErr: action.payload,
      };
    default:
      return state;
  }
};